export default{
    caminos: [],
    caminoSelec: null,
}